/**
 * @generated SignedSource<<4c718842da8cd8a47fe5abd63b9e51da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionPercentageOff_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePercentageOff_item">;
  readonly " $fragmentType": "PdpSharedAuctionPercentageOff_item";
};
export type PdpSharedAuctionPercentageOff_item$key = {
  readonly " $data"?: PdpSharedAuctionPercentageOff_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionPercentageOff_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionPercentageOff_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "usePercentageOff_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3dca57ebc6c05f5b47673ee58e507951";

export default node;
